import React from 'react';
import { HiTrendingUp } from 'react-icons/hi';
import SettingsSection from './SettingsSection';
import Select from '../common/Select';
import NumberInput from '../common/NumberInput';
import Toggle from '../common/Toggle';
import { useSettings } from '../../context/SettingsContext';

const StrategySettings = () => {
  const { settings, updateSettings } = useSettings();
  const { strategy } = settings;

  const signalOptions = [
    { value: 'RSI', label: 'RSI' },
    { value: 'MACD', label: 'MACD' },
    { value: 'BB', label: '볼린저밴드' },
    { value: 'MA', label: '이동평균선' },
  ];

  const positionSizingOptions = [
    { value: 'fixed', label: '고정' },
    { value: 'variable', label: '변동' },
    { value: 'kelly', label: '켈리공식' },
  ];

  const orderTypeOptions = [
    { value: 'market', label: '시장가' },
    { value: 'limit', label: '지정가' },
  ];

  return (
    <SettingsSection title="거래 전략 설정" icon={HiTrendingUp}>
      {/* 진입 조건 */}
      <div>
        <h4 className="text-sm font-semibold text-gray-300 mb-3">진입 조건</h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Select
            label="진입 신호"
            value={strategy.entrySignal}
            onChange={(value) => updateSettings('strategy', 'entrySignal', value)}
            options={signalOptions}
          />
          <NumberInput
            label="진입 임계값"
            value={strategy.entryThreshold}
            onChange={(value) => updateSettings('strategy', 'entryThreshold', value)}
            min={0}
            max={100}
            step={1}
          />
          <NumberInput
            label="신호 확인 기간"
            value={strategy.confirmationPeriod}
            onChange={(value) => updateSettings('strategy', 'confirmationPeriod', value)}
            min={1}
            max={60}
            step={1}
            unit="분"
          />
        </div>
      </div>

      {/* 청산 조건 */}
      <div>
        <h4 className="text-sm font-semibold text-gray-300 mb-3">청산 조건</h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Select
            label="청산 신호"
            value={strategy.exitSignal}
            onChange={(value) => updateSettings('strategy', 'exitSignal', value)}
            options={signalOptions}
          />
          <NumberInput
            label="청산 임계값"
            value={strategy.exitThreshold}
            onChange={(value) => updateSettings('strategy', 'exitThreshold', value)}
            min={0}
            max={100}
            step={1}
          />
          <div className="sm:col-span-2">
            <Toggle
              label="트레일링 스탑 활성화"
              checked={strategy.trailingStop}
              onChange={(value) => updateSettings('strategy', 'trailingStop', value)}
            />
          </div>
          {strategy.trailingStop && (
            <NumberInput
              label="트레일링 스탑 비율"
              value={strategy.trailingStopPercent}
              onChange={(value) => updateSettings('strategy', 'trailingStopPercent', value)}
              min={0.1}
              max={10}
              step={0.1}
              unit="%"
            />
          )}
        </div>
      </div>

      {/* 포지션 관리 */}
      <div>
        <h4 className="text-sm font-semibold text-gray-300 mb-3">포지션 관리</h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Select
            label="포지션 크기 방식"
            value={strategy.positionSizing}
            onChange={(value) => updateSettings('strategy', 'positionSizing', value)}
            options={positionSizingOptions}
          />
          <Select
            label="주문 유형"
            value={strategy.orderType}
            onChange={(value) => updateSettings('strategy', 'orderType', value)}
            options={orderTypeOptions}
          />
          <NumberInput
            label="허용 슬리피지"
            value={strategy.slippage}
            onChange={(value) => updateSettings('strategy', 'slippage', value)}
            min={0}
            max={5}
            step={0.1}
            unit="%"
          />
        </div>
      </div>
    </SettingsSection>
  );
};

export default StrategySettings;
